module.exports = __webpack_public_path__ + "img/logo.106abe3b.svg";